(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mailchimp-signup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('mailchimp-signup-form')) return;

  class MailchimpSignupForm extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;

      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.buttonText = this.button?.querySelector('span');
      this.status = this.querySelector('.mailchimp-signup-form__status');
      this.emailInput = this.querySelector('input[type="email"]');

      if (!this.form || !this.button || !this.status || !this.emailInput) return;

      this.handleSubmit = this.handleSubmit.bind(this);
      this.clearError = this.clearError.bind(this);
      this.form.addEventListener('submit', this.handleSubmit);
      this.emailInput.addEventListener('input', this.clearError);
      this.initialised = true;
    }

    disconnectedCallback() {
      if (!this.initialised) return;
      this.form?.removeEventListener('submit', this.handleSubmit);
      this.emailInput?.removeEventListener('input', this.clearError);
      this.cleanupRequest();
      this.initialised = false;
    }

    clearError() {
      if (this.status?.dataset.status === 'error') this.setStatus('', '');
    }

    handleSubmit(event) {
      event.preventDefault();

      if (this.busy || !this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      this.setBusy(true);
      this.setStatus('', '');

      const endpoint = this.dataset.endpoint;
      const callbackName = `mailchimpSignup_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      const params = new URLSearchParams(new FormData(this.form));
      params.set('c', callbackName);

      const script = document.createElement('script');
      script.async = true;
      script.src = `${endpoint}${endpoint.includes('?') ? '&' : '?'}${params.toString()}`;

      this.activeScript = script;
      this.activeCallback = callbackName;

      window[callbackName] = (response) => {
        const message = this.toPlainText(response?.msg || '');
        const alreadySubscribed = /already subscribed/i.test(message);

        if (response?.result === 'success') {
          this.form.reset();
          this.setStatus('success', this.dataset.successMessage || message);
        } else if (alreadySubscribed) {
          this.form.reset();
          this.setStatus('success', this.dataset.alreadySubscribedMessage || message);
        } else {
          this.setStatus('error', message || this.dataset.errorMessage);
        }

        this.finishRequest();
      };

      script.addEventListener('error', () => {
        this.setStatus('error', this.dataset.errorMessage);
        this.finishRequest();
      }, { once: true });

      this.requestTimeout = window.setTimeout(() => {
        this.setStatus('error', this.dataset.errorMessage);
        this.finishRequest();
      }, 15000);

      document.body.appendChild(script);
    }

    toPlainText(value) {
      const element = document.createElement('div');
      element.innerHTML = String(value);
      return (element.textContent || '').replace(/^\s*\d+\s*-\s*/, '').trim();
    }

    setBusy(isBusy) {
      this.busy = isBusy;
      this.button.disabled = isBusy;
      this.button.setAttribute('aria-busy', String(isBusy));

      if (this.buttonText) {
        this.buttonText.textContent = isBusy
          ? (this.dataset.loadingText || 'Subscribing...')
          : (this.button.dataset.label || 'Subscribe');
      }
    }

    setStatus(type, message) {
      this.status.textContent = message || '';

      if (type) {
        this.status.dataset.status = type;
        this.status.setAttribute('role', type === 'error' ? 'alert' : 'status');
      } else {
        this.status.removeAttribute('data-status');
        this.status.setAttribute('role', 'status');
      }

      if (type === 'error') {
        this.emailInput.setAttribute('aria-invalid', 'true');
      } else {
        this.emailInput.removeAttribute('aria-invalid');
      }

      if (message) this.status.focus({ preventScroll: true });
    }

    finishRequest() {
      this.cleanupRequest();
      this.setBusy(false);
    }

    cleanupRequest() {
      if (this.requestTimeout) {
        window.clearTimeout(this.requestTimeout);
        this.requestTimeout = null;
      }

      if (this.activeScript) {
        this.activeScript.remove();
        this.activeScript = null;
      }

      if (this.activeCallback) {
        const callbackName = this.activeCallback;
        window[callbackName] = () => {};
        window.setTimeout(() => {
          try {
            delete window[callbackName];
          } catch (error) {
            window[callbackName] = undefined;
          }
        }, 60000);
        this.activeCallback = null;
      }
    }
  }

  customElements.define('mailchimp-signup-form', MailchimpSignupForm);
})();

  } catch(e) { console.error(e); }
})();
})();
